import React from 'react';
import { CheckRounded } from '@mui/icons-material';
import SectionLabel from './SectionLabel';

/* One of the three product layers: numbered copy on one side, a diagram on the
   other, and an optional full-width `footer` beneath both columns. */
function LayerBlock({ number, name, title, intro, points, diagram, side = 'right', footer }) {
  return (
    <div className={`layer layer--diagram-${side}`}>
      <div className="layer__text">
        <div className="layer__head">
          <span className="layer__number">{number}</span>
          <SectionLabel className="layer__name">{name}</SectionLabel>
        </div>
        <h3>{title}</h3>
        <p className="layer__intro">{intro}</p>
        <ul className="layer__points">
          {points.map((point) => (
            <li key={point}>
              <span className="layer__tick" aria-hidden="true">
                <CheckRounded fontSize="inherit" />
              </span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="layer__diagram">{diagram}</div>
      {footer && <div className="layer__footer">{footer}</div>}
    </div>
  );
}

export default LayerBlock;
